import { RSAA } from 'redux-api-middleware'
import {
  getApiPath,
  makeApiTypes,
  makeQueryParams,
  webStorage,
} from 'sidecar-utility-library'

export const types = {
  ...makeApiTypes('SAVE_UNCOVERED_APPLICANT', 'uncoveredApplicant'),
}

export const saveUncoveredApplicant = applicant => ({
  [RSAA]: {
    endpoint: getApiPath(
      'acct',
      `pub/uncovered-applicants${makeQueryParams({
        urlSlug: webStorage.getItem('ptnr'),
      })}`,
    ),
    method: 'POST',
    body: JSON.stringify(applicant),
    headers: {
      'x-api-key': process.env.REACT_APP_X_API_KEY,
    },
    types: [
      types.SAVE_UNCOVERED_APPLICANT_REQUEST,
      {
        type: types.SAVE_UNCOVERED_APPLICANT_SUCCESS,
        meta: { email: applicant.email },
      },
      types.SAVE_UNCOVERED_APPLICANT_ERROR,
    ],
  },
})

const initialState = {
  applicants: {
    busy: false,
    error: null,
    email: null,
  },
}

export default (
  state = initialState,
  { type, payload = {}, meta = {} } = {},
) => {
  switch (type) {
    case types.SAVE_UNCOVERED_APPLICANT_REQUEST: {
      return {
        ...state,
        applicants: {
          ...state.applicants,
          busy: true,
          error: null,
        },
      }
    }

    case types.SAVE_UNCOVERED_APPLICANT_SUCCESS: {
      // success returns a 204 so no response
      return {
        ...state,
        applicants: {
          busy: false,
          error: null,
          email: meta.email,
        },
      }
    }

    case types.SAVE_UNCOVERED_APPLICANT_ERROR: {
      return {
        ...state,
        applicants: {
          ...state.applicants,
          busy: false,
          error: payload.response.message,
        },
      }
    }

    default:
      return state
  }
}
